import { useNavigate } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import facebookLogo from "../../components/Layout/facebook.png";
import instagramLogo from "../../components/Layout/instagram.png";
import draxLogo from "../../components/Layout/logo2.png";
import naverLogo from "../../components/Layout/naver.png";
import "./style.css";



function Home() {
  const navigate = useNavigate();
  return (
    <div className="my-5" style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
      <div style={{ width: "90%", maxWidth: "600px", }}>

        <h1 className="align-center py-2 my-4">디랙스 서비스센터</h1>
        <div className="ui divider"></div>

        <div className="my-3 px-5">
          <Button fluid size="large" className="my-2 py-4" onClick={() => navigate('/warranty')}>고장접수</Button>
          <Button fluid size="large" className="my-2 py-4" onClick={() => navigate('/receipt')}>접수내역 확인</Button>
          <Button fluid size="large" className="my-2 py-4" onClick={() => navigate('/solutions')}>스스로해결</Button>
          <Button
            fluid
            size="large"
            className="my-2 py-4"
            onClick={() => window.open('https://smartstore.naver.com/drax', '_blank')}
          >
            스마트스토어
          </Button>
        </div>

        {/* footer */}
        <div className="ui divider"/>
        <div className="information2 row" style={{ display: "flex" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: '0',
              paddingTop: '0',
              paddingBottom: '1rem'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
              <div style={{ flex: '0 0 80%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                <img
                  src={draxLogo}
                  alt="Drax"
                  className="py-1"
                  style={{ width: '100%', height: 'auto', maxWidth: '200px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.draxfit.com/', '_blank')}
                />
              </div>
              <div style={{ flex: '0 0 20%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20%' }}>
                <img
                  src={naverLogo}
                  alt="Naver"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://blog.naver.com/draxfit_official/', '_blank')}
                />
                <img
                  src={instagramLogo}
                  alt="Instagram"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.instagram.com/draxfit_official/', '_blank')}
                />
                <img
                  src={facebookLogo}
                  alt="Facebook"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.facebook.com/DRAXFIT/', '_blank')}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              textAlign: 'left',
              fontSize: '0.75rem',
              paddingBottom: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <div style={{ fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '8px' , marginTop: '27px'}}>주식회사 디랙스</div>
            <div style={{ marginBottom: '0.5px' }}>본사/제1공장 : 경기 안양시 만안구 전파로62번길 26</div>
            <div style={{ marginBottom: '0.5px' }}>제2공장 : 경기 안양시 만안구 전파로 48</div>
            <div style={{ marginBottom: '0.5px' }}>제3공장 : 경기 안양시 만안구 덕천로72번길 85</div>
            <div style={{ marginBottom: '0.5px' }}>사업자등록번호 123-81-70002</div>
            <div style={{ marginBottom: '0.5px' }}>TEL: 031-459-8530 / FAX: 031-459-8531</div>
          </div>
        </div>
        {/* footer */}

      </div>
    </div>
  )
}

export default Home;
